import { render, staticRenderFns } from "./BtnZzimTemplate.vue?vue&type=template&id=30092766"
import script from "./BtnZzimTemplate.vue?vue&type=script&lang=js"
export * from "./BtnZzimTemplate.vue?vue&type=script&lang=js"
import style0 from "./BtnZzimTemplate.vue?vue&type=style&index=0&id=30092766&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports